import React, {ReactNode, useEffect, useState} from "react";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import {Box, Button, Checkbox, Drawer, FormControlLabel, FormGroup, IconButton, Popover, Typography} from "@mui/material";
import {Apps, ExpandCircleDown, ManageAccounts, Menu as MenuIcon} from "@mui/icons-material";
import {Blue3, Grey6} from "../theme/styles";
import css_self from "./css/Pages.module.scss";
import css_button from "../components/Common/css/CCButton.module.scss";
import useBreakpoint from "../util/useBreakpoint";
import ProjectPlanTableApplet from "../eoec/applet/impl/BusinessProcessModel/BusinessProcessModelTableApplet";
import EventBus from "../util/EventBus";
import {useSessionContext} from "../util/SessionContext";
import css_buttons from "../components/Common/css/CCButton.module.scss";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option1: string | null, option2: string | null}

export default function BusinessProcessModel() {
    const breakpoint = useBreakpoint();
    const sessionContext = useSessionContext();

    function onChangeVisibility() {
        businessProcessModelEnterpriseObject?.getEnterpriseComponent("BusinessProcessModel")?.invalidate()
    }

    const [businessProcessModelEnterpriseObject] = useState(enterpriseObjectClassFactory("BusinessProcessModel") as EnterpriseObject);

    const [drawerVisibility, setDrawerVisibility] = React.useState<boolean>(false);
    const [dashboardMenu, setDashboardMenu] = React.useState(1);
    const [viewOption, setViewOption] = React.useState<string | null>("Position");
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    useEffect(() => {
        EventBus.visibility.addListener("change-visibility", onChangeVisibility);

        return () => {
            EventBus.visibility.removeListener("change-visibility", onChangeVisibility);
        }
    });

    let contents

    const toggleDrawer = (newOpen: boolean) => () => {
        setDrawerVisibility(newOpen);
    };

    if (breakpoint.getBreakPointName() !== "xl" && breakpoint.getBreakPointName() !== "lg") {
        contents = (
            <div>
                <Drawer style={{backgroundColor: "#FAFAFA"}} open={drawerVisibility} onClose={toggleDrawer(!drawerVisibility)}>
                    <div style={{marginTop: breakpoint.getBreakPointName() !== "xl" && breakpoint.getBreakPointName() !== "lg" ? "100px": "0px", paddingLeft: "5px", paddingTop: "2px"}}>
                    </div>
                </Drawer>
            </div>
        )
    }

    let businessProcessModel = null;
    if (dashboardMenu === 1) {
        let commonContent = (
            <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", height: "100vh", paddingRight: "60px"}}>
                {breakpoint.getBreakPointName() === "lg" || breakpoint.getBreakPointName() === "xl" ? (
                    <>
                        <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                            <ProjectPlanTableApplet enterpriseComponent={businessProcessModelEnterpriseObject?.getEnterpriseComponent("BusinessProcessModel")}/>
                        </div>
                    </>
                ) : (
                    <div style={{paddingLeft: "5px", width: "48px", height: "100vh", borderRight: "1px solid #DDDDDD", backgroundColor: "#FAFAFA"}}>
                        {drawerVisibility ? contents : (<Button className={css_self.PagesButton} variant="text" startIcon={<MenuIcon sx={{width: 28, height: 35, color: Grey6}} onClick={() => setDrawerVisibility(!drawerVisibility)}/>}/>)}
                    </div>
                )}
            </div>
        )

        let visibility_modes = ["Multiple Company", "Organization", "Management", "Position", "User Group", "Work Group"]

        function renderVisibilityMenu(visibilityBeingRendered: string) {
            let out: ReactNode;

            if ((visibilityBeingRendered === "Multiple Company") && sessionContext.getPrivileges().includes("Business Process Model Multiple Company") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "Multiple Company" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}} >
                        <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                            <div>
                                <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                                    sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                                    setViewOption(visibilityBeingRendered)
                                    EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                                }}>{visibilityBeingRendered}</Button>
                            </div>
                            <div style={{marginLeft: "7px", marginTop: "6px"}}>
                                <IconButton className={css_button.blueIconButton} onClick={(e) => setMenu({id: "tenants", target: e.currentTarget, option1: null, option2: null})}>
                                    <ExpandCircleDown/>
                                </IconButton>
                                {menu?.id === "tenants" ? (
                                    <Popover anchorEl={menu.target}
                                             anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                                             transformOrigin={{vertical: -12, horizontal: "left"}}
                                             open={true}
                                             onClose={() => setMenu(null)}
                                             TransitionProps={{
                                                 onExited: () => setMenu(null),
                                             }}
                                             PaperProps={{
                                                 elevation: 2,
                                             }}
                                    >
                                        <Box sx={{p: 2, bgcolor: "background.paper", width: "auto", height: "auto"}}>
                                            <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                                <div style={{}}>
                                                    <Typography style={{fontSize: "18px", fontWeight: "400", color: "#000000", textAlign: "left", borderBottom: "1px solid #D8DDE4"}}>Available Companies</Typography>
                                                </div>
                                                <div style={{marginTop: "10px"}}>
                                                    <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "left"}}>Please select:</Typography>
                                                </div>
                                                <div>
                                                    <FormGroup>
                                                        {sessionContext.getTenants().map(tenant => (
                                                            <FormControlLabel style={{marginBottom: "5px"}} control={<Checkbox defaultChecked />} label={tenant.Name} />
                                                        ))}
                                                    </FormGroup>
                                                </div>
                                                <div style={{marginTop: "20px", marginLeft: "auto", marginRight: "auto"}}>
                                                    <Button
                                                        className={css_buttons.blueStandardButton} style={{width: "200px"}}
                                                        onClick={() => null}>
                                                        Select
                                                    </Button>
                                                </div>
                                            </div>
                                        </Box>
                                    </Popover>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )
            } else if ((visibilityBeingRendered === "Organization") && sessionContext.getPrivileges().includes("Business Process Model Organization") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "Organization" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}  >
                        <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                            sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                            setViewOption(visibilityBeingRendered)
                            EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                        }}>{visibilityBeingRendered}</Button>
                    </div>
                )
            } else if ((visibilityBeingRendered === "Management") && sessionContext.getPrivileges().includes("Business Process Model Management") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "Management" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}  >
                        <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                            sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                            setViewOption(visibilityBeingRendered)
                            EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                        }}>{visibilityBeingRendered}</Button>
                    </div>
                )
            } else if ((visibilityBeingRendered === "Position") && (sessionContext.getActiveVisibility()!.Mode === "Multiple Company" || sessionContext.getActiveVisibility()!.Mode === "Position" || sessionContext.getActiveVisibility()!.Mode === "Organization" || sessionContext.getActiveVisibility()!.Mode === "Management")) {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "Position" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                        <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                            sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                            setViewOption(visibilityBeingRendered)
                            EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                        }}>{visibilityBeingRendered}</Button>
                    </div>
                )
            } else if ((visibilityBeingRendered === "User Group") && sessionContext.getActiveVisibility()!.Mode === "User Group") {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "User Group" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                        <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                            sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                            setViewOption(visibilityBeingRendered)
                            EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                        }}>{visibilityBeingRendered}</Button>
                    </div>
                )
            } else if ((visibilityBeingRendered === "Work Group") && sessionContext.getActiveVisibility()!.Mode === "Work Group") {
                out = (
                    <div style={sessionContext.getActiveVisibility()!.Mode === "Work Group" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                        <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                            sessionContext.setActiveVisibility(visibilityBeingRendered, sessionContext.getActiveVisibility()!.Value);
                            setViewOption(visibilityBeingRendered)
                            EventBus.visibility.emit("change-visibility", sessionContext.getActiveVisibility());
                        }}>{visibilityBeingRendered}</Button>
                    </div>
                )
            }

            return out;
        }

        businessProcessModel = (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #EFEFEF", paddingBottom: "15px", height: "40px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                        {visibility_modes.map((visibility_mode, i) => (
                            <div key={visibility_mode} style={{paddingTop: "10px", marginLeft: i === 0 || i === 1 ? "15px" : "35px"}}>
                                {renderVisibilityMenu(visibility_mode)}
                            </div>
                        ))}
                    </div>
                </div>
                {viewOption === "Multiple Company" ? (
                    commonContent
                ): null}
                {viewOption === "Organization" ? (
                    commonContent
                ): null}
                {viewOption === "Management" ? (
                    commonContent
                ): null}
                {viewOption === "Position" ? (
                    commonContent
                ): null}
                {viewOption === "User Group" ? (
                    commonContent
                ): null}
                {viewOption === "Work Group" ? (
                    commonContent
                ): null}
            </>
        )
    }

    let visibilityMode = sessionContext.getActiveVisibility()!.Mode;
    let visibilityValue = sessionContext.getActiveVisibility()!.Value;
    let visibilityTitle = null;

    if (visibilityMode === "Organization") {
        for (let i = 0; i < sessionContext.getCompany()!["Positions"].length; i++) {
            if (sessionContext.getCompany()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getCompany()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "Management") {
        for (let i = 0; i < sessionContext.getCompany()!["Positions"].length; i++) {
            if (sessionContext.getCompany()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getCompany()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "Position") {
        for (let i = 0; i < sessionContext.getCompany()!["Positions"].length; i++) {
            if (sessionContext.getCompany()!["Positions"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getCompany()!["Positions"][i].Name;
                visibilityMode = "Position";
                break;
            }
        }
    } else if (visibilityMode === "User Group") {
        for (let i = 0; i < sessionContext.getCompany()!["UserGroups"].length; i++) {
            if (sessionContext.getCompany()!["UserGroups"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getCompany()!["UserGroups"][i].Name;
                visibilityMode = "User Group";
                break;
            }
        }
    } else if (visibilityMode === "Work Group") {
        for (let i = 0; i < sessionContext.getCompany()!["WorkGroups"].length; i++) {
            if (sessionContext.getCompany()!["WorkGroups"][i].USID === visibilityValue) {
                visibilityTitle = sessionContext.getCompany()!["WorkGroups"][i].Name;
                visibilityMode = "Work Group";
                break;
            }
        }
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Business Process Model</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                    <div style={{display: "flex", flexDirection: "column", paddingTop: "5px", marginRight: "20px"}}>
                        <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{sessionContext.getActiveVisibility()!.Mode}</Typography>
                        <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{visibilityMode}: {visibilityTitle}</Typography>
                    </div>
                    <div>
                        <IconButton className={css_self.DashboardMenuButton} onClick={(e) => setMenu({id: "apps", target: e.currentTarget, option1: null, option2: null})}>
                            <Apps/>
                        </IconButton>
                        {menu?.id === "apps" ? (
                            <Popover anchorEl={menu.target}
                                     anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                     transformOrigin={{vertical: -12, horizontal: "left"}}
                                     open={true}
                                     onClose={() => setMenu(null)}
                                     TransitionProps={{
                                         onExited: () => setMenu(null),
                                     }}
                                     PaperProps={{
                                         elevation: 2,
                                     }}
                            >
                                <Box sx={{p: 2, bgcolor: "background.paper", width: "375px", height: "375px"}}>
                                    <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                        <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                                            <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                                <IconButton className={css_self.AppMenuButton}
                                                    onClick={() => {
                                                        setMenu(null)
                                                        setDashboardMenu(1)
                                                    }}>
                                                    <ManageAccounts sx={{color: Blue3, width: 45, height: 45}}/>
                                                </IconButton>
                                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Business Process Model</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </Popover>
                        ) : null}
                    </div>
                </div>
            </div>
            {businessProcessModel}
        </div>
    );
}